import Spotify6 from './Spotify6'
export default Spotify6
